import { render } from "./CircleProgressRing.vue?vue&type=template&id=5a2aa8e2&ts=true"
import script from "./CircleProgressRing.vue?vue&type=script&lang=ts"
export * from "./CircleProgressRing.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__